import { apiInstance, legacyV2Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const project = {
  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/project`,
      params
    })
  },

  getById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/project/${id}`
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/project`,
      data
    })
  },

  update (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2Path()}/project/${id}`,
      data
    })
  },

  delete (id) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2Path()}/project/${id}`
    })
  }
}

export default project
